import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import SectionContainer from "../SectionContainer";
import styles from "./mapSection.module.scss";
import MapInfoTabsV3 from "./Components/MapInfoTabsV3";
import useMapbox from "./Hooks/useMapbox";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import { MapProvider } from "./context/MapContext";
import { useRef } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

interface MapSectionV3Props {
  isDesktop?: boolean;
}

// Create a wrapper component that uses the MapProvider
const MapSectionV3Content = ({ isDesktop = true }: MapSectionV3Props) => {
  const { t } = useTranslationHook();
  const containerRef = useRef(null);
  const { inventory } = useSelector(
    ({ propertyPageData }: AppState) => ({
      inventory: propertyPageData?.data,
    }),
    shallowEqual,
  );
  // Initialize map
  const { handleOptionClick } = useMapbox({
    inventory,
    markerSize: 40,
    propertyMarkerSize: 48,
    containerRef,
  });

  return (
    <div ref={containerRef}>
      <SectionContainer
        title={t("propertypage.components.mapsectionv2.nearbylocationsandmaptitle")}
        id="map"
        className={formatClassNames(styles.container, isDesktop && styles.desktop)}
      >
        <MapInfoTabsV3
          isDesktop={isDesktop}
          inventory={inventory}
          isDesktopStreetView={false}
          handleOptionClick={handleOptionClick}
        />
      </SectionContainer>
    </div>
  );
};

// Main component that provides the context
const MapSectionV3 = (props: MapSectionV3Props) => (
  <MapProvider>
    <MapSectionV3Content {...props} />
  </MapProvider>
);

export default wrapperHOC(MapSectionV3, {
  componentName: "MapSectionV3-PropertyPage-MapSectionV3",
  showForChina: true,
});
